import React from "react";
import { useNavigate } from "react-router-dom";
import { Home as HomeIcon, Car } from "lucide-react";

export default function Home() {
  const navigate = useNavigate();

  return (
    <main className="max-w-5xl mx-auto px-5 pt-16 pb-24 fade-in">
      <h1 className="text-center text-4xl md:text-5xl font-extrabold text-slate-600 tracking-tight">
        Cartas contempladas
      </h1>
      <div className="mx-auto mt-3 h-1 w-24 rounded-full gold-underline" />
      <p className="text-center mt-4 text-lg text-slate-500">Escolha um segmento:</p>

      <div className="grid grid-cols-2 gap-3 sm:gap-6 mt-10 max-w-3xl mx-auto">
        <button
          onClick={() => navigate("/imovel")}
          className="card-hover bg-white border border-slate-200 rounded-2xl py-8 sm:py-12 flex flex-col items-center gap-3 sm:gap-4"
        >
          <div className="h-14 w-14 sm:h-16 sm:w-16 rounded-2xl bg-[#faf1d6] flex items-center justify-center">
            <HomeIcon className="text-[#C9A227]" size={30} strokeWidth={1.8} />
          </div>
          <span className="text-base sm:text-lg font-bold text-slate-600 tracking-wide">IMÓVEL</span>
        </button>

        <button
          onClick={() => navigate("/veiculo")}
          className="card-hover bg-white border border-slate-200 rounded-2xl py-8 sm:py-12 flex flex-col items-center gap-3 sm:gap-4"
        >
          <div className="h-14 w-14 sm:h-16 sm:w-16 rounded-2xl bg-[#faf1d6] flex items-center justify-center">
            <Car className="text-[#C9A227]" size={30} strokeWidth={1.8} />
          </div>
          <span className="text-lg font-bold text-slate-600 tracking-wide">VEÍCULO</span>
        </button>
      </div>
    </main>
  );
}
